import { AnyAction, createReducer } from '@reduxjs/toolkit';
import {
	bulkUpdateSingleSubscriptionUsers,
	bulkUpdateSingleSubscriptionUsersRejected,
	bulkUpdateSingleSubscriptionUsersResolved,
	clearUserById,
	createUser,
	createUserRejected,
	createUserReset,
	createUserResolved,
	getSingleUser,
	getSingleUserResolved,
	getUsers,
	getUsersRejected,
	getUsersResolved,
	updateUser,
	updateUserResolved,
} from '@Actions/users';

import { UsersStoreState } from '@Types';
import { defaultUserById } from '@Types/user.types';

export const initialState: UsersStoreState = {
	initialized: false,
	created: false,
	paginatedUsers: {
		initialized: false,
		users: [],
		pagination: {
			total: 0,
			previous: 0,
			next: 0,
			current: 0,
			pages: 0,
		},
	},
	userById: defaultUserById,
	bulkUser: { status: 'idle' },
};

interface Users {
	[x: string]: (
		state: UsersStoreState,
		action: AnyAction,
	) => UsersStoreState | undefined;
}

const reducer: Users = {
	[getUsersResolved.toString()]: (state, action) => ({
		...state,
		initialized: true,
		paginatedUsers: {
			initialized: true,
			users: action.payload.users,
			pagination: action.payload.pagination,
		},
	}),
	[getUsersRejected.toString()]: state => ({
		...state,
		paginatedUsers: {
			users: [],
			pagination: {
				total: 0,
				previous: 0,
				next: 0,
				current: 0,
				pages: 0,
			},
			initialized: true,
		},
	}),
	[getUsers.toString()]: state => ({
		...state,
		paginatedUsers: {
			users: [],
			pagination: {
				total: 0,
				previous: 0,
				next: 0,
				current: 0,
				pages: 0,
			},
			initialized: false,
		},
	}),
	[createUser.toString()]: state => ({
		...state,
		created: false,
		initialized: false,
	}),
	[createUserResolved.toString()]: state => ({
		...state,
		created: true,
		initialized: true,
	}),
	[createUserReset.toString()]: state => ({
		...state,
		created: false,
		initialized: true,
	}),
	[createUserRejected.toString()]: state => ({
		...state,
		created: false,
		initialized: true,
	}),
	[getSingleUser.toString()]: state => ({
		...state,
		userById: {
			initialized: false,
		},
	}),
	[getSingleUserResolved.toString()]: (state, action) => ({
		...state,
		userById: {
			initialized: true,
			user: action.payload,
		},
	}),
	[updateUser.toString()]: state => ({
		...state,
	}),
	[updateUserResolved.toString()]: state => ({
		...state,
	}),
	[clearUserById.toString()]: state => ({
		...state,
		userById: defaultUserById,
	}),
	[bulkUpdateSingleSubscriptionUsers.toString()]: state => ({
		...state,
		bulkUser: { status: 'pending' },
	}),
	[bulkUpdateSingleSubscriptionUsersResolved.toString()]: (
		state,
		action,
	) => ({
		...state,
		bulkUser: { status: 'completed', results: action.payload },
	}),
	[bulkUpdateSingleSubscriptionUsersRejected.toString()]: (
		state,
		action,
	) => ({
		...state,
		bulkUser: { status: 'rejected', results: action.payload },
	}),
};

export default createReducer(initialState, reducer);
